import { actions } from '../../utils/constants';

export const updateClass = (classId, value) => ({
    type: actions.UPDATE_CLASS,
    payload: {
        classId,
        value,
    },
});

export const fetchClass = (classId) => ({
    type: actions.ASYNC_FETCH_CLASS,
    payload: classId,
});

export const fetchCourse = (courseId) => ({
    type: actions.ASYNC_FETCH_COURSE,
    payload: courseId,
});

export const uploadFile = (dataUri, cb = () => {}, mime) => ({
    type: actions.UPLOAD_FILE,
    payload: {
        dataUri,
        cb,
        mime,
    },
});



// WEBPACK FOOTER //
// ./src/components/section/section.actions.js